// This function allow to reference chunks
__webpack_require__.u = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "async/appvue." + {"445": "f48311ba","624": "c8b7e87d","66": "3377ecdb","714": "4aa476c6","739": "1d2be111",}[chunkId] + ".js"
}